import type { SegmentTrackPageElementClickedEvent } from "@beautypie/segment/Track/PageElementClicked"
import { track } from "tracking"

export const trackSegmentPageElementClicked = (
  moduleContent: string,
  modulePosition?: number,
  moduleContentDetails?: string,
  moduleContentUrl?: string
): void => {
  const data: SegmentTrackPageElementClickedEvent = {
    event: "Page Element Clicked",
    properties: {
      module_content: moduleContent,
      module_position: modulePosition,
      module_content_details: moduleContentDetails,
      module_content_url: moduleContentUrl,
    },
  }

  track(data)
}
